import styled from 'styled-components';
import { GameMainLayout } from './MainLayout';
import Student from '../components/Student';
import { headerHeight } from '../style/theme';

const StyledInnerContainer = styled.div`
    min-height: calc(100% - ${headerHeight}px);
    padding: 0 32px 32px 32px;
`;

const GamePresetView = () => {
    return (
        <GameMainLayout fullscreen={false}>
            <StyledInnerContainer>
                <Student />
            </StyledInnerContainer>
        </GameMainLayout>
    );
};
export default GamePresetView;
